import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AuditTrailPanel = () => {
  const { currentLanguage, t } = useLanguage();
  const [auditLogs, setAuditLogs] = useState([]);

  useEffect(() => {
    // Mock audit logs - in production, fetch from Supabase
    const mockLogs = [
      {
        id: 1,
        action: 'pilgrim_created',
        user: 'Ahmed Benali',
        details: 'Added new pilgrim: Mohamed Alami',
        timestamp: new Date()?.toISOString(),
        type: 'create'
      },
      {
        id: 2,
        action: 'visa_status_updated',
        user: 'Fatima Zahra',
        details: 'Updated visa status to approved for Amina Idrissi',
        timestamp: new Date(Date.now() - 3600000)?.toISOString(),
        type: 'update'
      },
      {
        id: 3,
        action: 'document_uploaded',
        user: 'System',
        details: 'Passport document uploaded for Hassan Bennani',
        timestamp: new Date(Date.now() - 7200000)?.toISOString(),
        type: 'document'
      },
      {
        id: 4,
        action: 'group_assigned',
        user: 'Ahmed Benali',
        details: 'Assigned 5 pilgrims to Omra Janvier 2026',
        timestamp: new Date(Date.now() - 86400000)?.toISOString(),
        type: 'assignment'
      }
    ];
    setAuditLogs(mockLogs);
  }, []);

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })?.format(date);
  };

  const getActionIcon = (type) => {
    switch (type) {
      case 'create': return 'UserPlus';
      case 'update': return 'Edit';
      case 'document': return 'FileText';
      case 'assignment': return 'Users';
      default: return 'Activity';
    }
  };

  const getActionColor = (type) => {
    switch (type) {
      case 'create': return 'text-success';
      case 'update': return 'text-primary';
      case 'document': return 'text-warning';
      case 'assignment': return 'text-primary';
      default: return 'text-muted-foreground';
    }
  };

  return (
    <div className="bg-card rounded-lg border border-border shadow-warm p-4 md:p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-foreground">
            {currentLanguage === 'fr' ? 'Piste d\'Audit de Conformité' : 'سجل التدقيق والامتثال'}
          </h3>
          <p className="caption text-muted-foreground mt-1">
            {currentLanguage === 'fr' ? 'Historique des modifications pour la conformité' : 'سجل التعديلات للامتثال'}
          </p>
        </div>
        <Button
          variant="outline"
          size="sm"
          iconName="Download"
          iconPosition="left"
        >
          {t('common.export')}
        </Button>
      </div>

      <div className="space-y-4">
        {auditLogs?.map((log) => (
          <div
            key={log?.id}
            className="flex items-start gap-4 p-4 bg-muted/50 rounded-lg hover:bg-muted transition-smooth"
          >
            <div className={`p-2 rounded-full bg-background ${getActionColor(log?.type)}`}>
              <Icon name={getActionIcon(log?.type)} size={20} />
            </div>
            <div className="flex-1">
              <div className="flex items-start justify-between gap-2">
                <div>
                  <p className="text-sm font-medium text-foreground">
                    {log?.details}
                  </p>
                  <p className="caption text-muted-foreground mt-1">
                    {currentLanguage === 'fr' ? 'Par' : 'بواسطة'}: {log?.user}
                  </p>
                </div>
                <span className="caption text-muted-foreground whitespace-nowrap">
                  {formatTimestamp(log?.timestamp)}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {auditLogs?.length === 0 && (
        <div className="text-center py-12">
          <Icon name="FileText" size={48} className="text-muted-foreground mx-auto mb-3" />
          <p className="text-muted-foreground">
            {currentLanguage === 'fr' ? 'Aucune entrée d\'audit' : 'لا توجد سجلات تدقيق'}
          </p>
        </div>
      )}
    </div>
  );
};

export default AuditTrailPanel;